// extracted by mini-css-extract-plugin
export default {"container":"VerifyDetailsIntro_container__1GkTH","checkIcon":"VerifyDetailsIntro_checkIcon__zDK4t","text":"VerifyDetailsIntro_text__93-NG"};